// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"328":"admin","343":"onboarding","674":"iso","710":"merchant","983":"payments"}[chunkId] + "." + {"328":"8f36daaf","343":"6cbe3506","674":"5f237b89","710":"5994d649","983":"f0b48ab6"}[chunkId] + ".css";
};